
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Letournel_Judet_classification_of_acetabular_fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Letournel_Judet_classification_of_acetabular_fractures.vue